import tools from './tools'
import isValid from './isValid'
import { Message } from 'iview'
import router from '../router'
import vue from "../main";
import errorCode from './errorCode'
import { locale } from 'moment';
import CryptoJS from "crypto-js";
import store from '../store'

//获取token的方法
const getToken = () => {

  if (isValid.isExp()) {
    // let token = tools.getSession('token');
    let token = tools.getLocal('token');
    // console.log('token',token)
    return token;
  } else {
    window.timeOut = 1;
    return false;
  }
}
//获取deleartoken的方法
const getDearlerToken = () => {

  if (isValid.isExp()) {
    // let token = tools.getSession('token');
    let token = tools.getLocal('dealerToken');
    // console.log('token',token)
    return token;
  } else {
    window.timeOut = 1;
    return false;
  }
}

/**
 * ajax  请求后状态处理
 * @param data object 请求后返回的数据   
 * @param off  boolean 参数的状态值    
 * @param fn  function 回调函数    
 * @param fn1  function 失败时回调函数    
 * @param show  boolean 是否弹框    
 */
const ajaxMsg = (data, off, fn, fn1, show) => {
  off = (off === true ? true : false)
  show = (show === false ? false : true)
  //   let hasAuthorization = getToken()
  //   console.log('hasAuthorization',hasAuthorization,isValid.isExp())

  // if(!hasAuthorization ){
  //   Message.error({
  //     content:'Login has expired. Please login again1111'
  //   })
  //   return false
  // }

  let local = sessionStorage.getItem('local') || localStorage.getItem('local') || 'en-US'
  let info = data.message

  // let localLang1 = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'en' || navLang === 'zh') ? navLang : false
  // let langObj = {'en':'en-US','en-US':'en-US','zh':'zh-CN','zh-CN':'zh-CN'}
  // let localLang = langObj[localLang1]
  // let local = tools.getLocal1('local') || localLang || 'en-US'

  let langArr = ['en-US', 'en_US', 'en']
  if (langArr.includes(local) && errorCode[data.code]) {
    info = errorCode[data.code]
  }

  if ((data.code != 1 && data.code != 3 && data.code != 11009) && show === true) {

    Message.error({
      content: info || vue.$i18n.t("failed") || 'failed',
      onClose: fn1 ? () => { fn1() } : function () { }
    })
    return false
  }


  if (data.code == 1 && off === true && show === true) {
    Message.success({
      content: data.message || vue.$i18n.t("success") || 'success',
      onClose: fn ? () => { fn() } : function () { }
    })
    return true
  }

  if (data.code == 1 && off === false && show === true) {
    fn ? fn() : () => { }
    return true
  }


  // if(data.code == 3){
  //   window.refreshToken = 2;
  //   sessionStorage.clear();
  //   router.push({name:data.data.url});
  //   return;
  // }


  if (fn && data.code != 11009 && show === false) {
    fn()
  }

}

/**
 * 通用消息框
 * @param type string 消息类型
 * @param content string 消息内容
 * @param fn function 回调
 * 
 */
const msg = (type, content, fn) => {

  // console.log('type',type,info)
  // let hasAuthorization = false

  // if (document.cookie.length > 0) {
  //     var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
  //     for (var i = 0; i < arr.length; i++) {
  //         var arr2 = arr[i].split('='); //再次切割
  //         //判断查找相对应的值
  //         if (arr2[0] == 'Authorization') {
  //           hasAuthorization = true
  //         }
  //     }
  // }

  if (content == 'Error: Request failed with status code 404') {
    return false
  }

  // if(!hasAuthorization && !content.code){
  //   Message.error({
  //     content:'Login has expired. Please login again'
  //   })
  //   return false
  // }

  let info = content

  if (Object.prototype.toString.call(content) == '[object Object]') {
    const navLang = navigator.language

    let localLang1 = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'en' || navLang === 'zh') ? navLang : false
    let langObj = { 'en': 'en-US', 'en-US': 'en-US', 'zh': 'zh-CN', 'zh-CN': 'zh-CN' }
    let localLang = langObj[localLang1]
    let local = tools.getLocal1('local') || localLang || 'en-US'


    let langArr = ['en-US', 'en_US', 'en']
    if (langArr.includes(local) && errorCode[content.code]) {
      info = errorCode[content.code]
    } else {
      info = content.message || content.msg || ''
    }

  }




  Message[type]({
    content: info,
    duration: 3,
    onClose: fn ? () => { fn() } : function () { }
  })
}


/**
 * 数组去重
 * @param arr Array 合并后的数组
 */
const unData = (arr) => {
  var map = {};
  if (arr && Array.isArray(arr)) {
    for (var i = arr.length; i >= 0; --i) {
      if (arr[i] in map) {
        arr.splice(arr[i], 1);
      } else {
        map[arr[i]] = true;
      }
    }
  }
  return arr;
}

let transPrice = (price) => {
  if (price == '' || price == 0) {
    return 0
  } else {
    return price = Number((price / 100).toFixed(3))
  }
}

/**
 * ajax  请求后状态处理
 * @param data object 请求后返回的数据   
 * @param off  boolean 参数的状态值    
 * @param fn  function 回调函数    
 * @param fn1  function 失败时回调函数    
 * @param show  boolean 是否弹框    
 */
const ajaxMsg1 = (data, off, fn, fn1, show) => {
  off = (off === true ? true : false)
  show = (show === false ? false : true)

  console.log('data', data)
  let local = sessionStorage.getItem('local') || localStorage.getItem('local')
  let info = data.message

  let langArr = ['en-US', 'en_US', 'en']
  if (langArr.includes(local) && errorCode[data.code]) {
    info = errorCode[data.code]
  }


  if ((data.code != 1 && data.code != 3) && off === true && show === true) {

    Message.error({
      content: info || vue.$i18n.t("failed") || 'failed',
      onClose: fn1 ? () => { fn1() } : function () { }
    })
    return false
  }
}

/**
 * 对象数组排序
 * @param prop string 排序的键名 
 */
const compare = function (prop) {
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (val1 < val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0;
    }
  }
}

/**
 * uinfo等数据加密
 * @param data  要加密的数据 
 */
const encryptDataUinfo = function (data, key = 'aes', string = 'uInfo') {

  let newUserInfo = data;
  //加密数据
  let encJson = CryptoJS.AES.encrypt(JSON.stringify(newUserInfo), key).toString();
  //对加密数据进行base64处理, 原理：就是先将字符串转换为utf8字符数组，再转换为base64数据
  let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
  localStorage.setItem(string, encData);

}
/**
 * uinfo等数据解密
 * @param data  要解密的数据 
 */
const decryptDataUinfo = function (key = 'aes', string = 'uInfo') {
  let decData = CryptoJS.enc.Base64.parse(localStorage.getItem(string)).toString(CryptoJS.enc.Utf8);
  //解密数据
  let decJson = CryptoJS.AES.decrypt(decData, key).toString(CryptoJS.enc.Utf8);
  let userInfo = JSON.parse(decJson);

  return userInfo

}

/**
 * 10进制转16进制 类型0x0f的格式
 *  @param num  要转换的数字
 */
const toHex = function (num) {//将一个数字转化成16进制字符串形式
  return num < 16 ? "0x0" + num.toString(16).toUpperCase() : "0x" + num.toString(16).toUpperCase();
}

/**
 * 深拷贝,递归实现，map用于解决循环引用的问题
 * @param obj  要拷贝的对象
 */

let map = new Map(); // WeakMap
const deepClone = function (obj) {
  let newobj = null;
  if (typeof (obj) == 'object' && obj !== null) {
    if (map.get(obj)) {
      newobj = map.get(obj) // 如果不想循环打印 可以设置为null
    } else {
      newobj = obj instanceof Array ? [] : {};
      map.set(obj, newobj)
      for (var i in obj) {
        newobj[i] = deepClone(obj[i])
      }
    }
  } else {
    newobj = obj
  }
  return newobj;
}

/**
 * 退出登录后清除数据
 */
const removeStorage = (store,router) => {
  let local = localStorage.getItem('local')
  let langSet = localStorage.getItem('langSet')
  let mapType = localStorage.getItem('mapType')
  let centerGeo = localStorage.getItem('centerGeo')
  localStorage.clear();
  sessionStorage.clear();
  store.commit('setTabMenuList', [{ activeId: "0-1", fId: 0, fTitle: "平台首页", name: "平台首页", routeName: "home", routerUrl: "/" }])
  store.commit('setTabMenuItem', { activeId: "0-1", fId: 0, fTitle: "平台首页", name: "平台首页", routeName: "home", routerUrl: "/" })
  document.cookie = "Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  localStorage.setItem('local', local)
  localStorage.setItem('langSet', langSet)
  localStorage.setItem('mapType', mapType)
  localStorage.setItem('centerGeo', centerGeo)
  router.push({ name: 'login', params: {} })
}


export default {
  getToken,
  getDearlerToken,
  ajaxMsg,
  msg,
  unData,
  transPrice,
  ajaxMsg1,
  compare,
  encryptDataUinfo,
  decryptDataUinfo,
  toHex,
  deepClone,
  removeStorage
}
